<template>
  <div id="app-root">
    <router-view></router-view>
    <WhatsAppBubble
      v-if="!$route.path.startsWith('/dashboard/team')"
      community-name="Peelo Chat Community"
      community-logo="/assets/group-logo.jpg"
      group-name="Peelo Community"
      group-logo="/assets/group-logo.jpg"
      message="Intégrez la communauté Peelo pour échanger plus facilement, découvrir les nouveautés en avant-première et obtenir de l’aide pour créer et optimiser vos agents IA."
      link="https://chat.whatsapp.com/Lm5n3hHWAjR7O5mdD8grtr"
    />
  </div>
</template>

<script>
import WhatsAppBubble from '@/components/WhatsAppBubble.vue';
import { syncSsoCookieFromStorage } from '@/utils/ssoCookie';
import { ensureIdentity } from '@/utils/accountSwitch';

export default {
  name: 'App',
  components: {
    WhatsAppBubble
  },
  mounted() {
    // Partage de compte : mémorise mon identité réelle (sauf si la session active est
    // déjà un compte partagé), pour pouvoir revenir à mon compte et autoriser les bascules.
    ensureIdentity();
    // SSO *.peelo.io : redépose le cookie de session pour que console.peelo.io
    // reconnaisse l'utilisateur déjà connecté ici (sessions antérieures incluses).
    syncSsoCookieFromStorage();
  }
}
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: 'Roboto', sans-serif !important;
}

:root {
  /* Couleurs principales */
  --primary-color: var(--whatsapp-green);
  --primary-light: rgba(37, 211, 102, 0.08);
  --secondary-color: #6c757d;
  
  /* Couleurs de fond */
  --bg-color: #f5f5f5;
  --bg-white: #fff;
  --bg-light: #f8fafc;
  
  /* Couleurs de texte */
  --text-color: #333;
  --text-muted: #6b7280;
  
  /* Couleurs utilitaires */
  --border-color: #e1e5eb;
  --hover-bg: #f0f2f5;
  --input-bg: ##f5f5f5;
  --gray-color: #9ca3af;
  --success-color: #10b981;
  --background-listuser: #f0f0f0;
  
  /* Couleurs WhatsApp */
  --whatsapp-green: #25D366;
  --whatsapp-dark: #075E54;
}

html, body {
  min-height: 100vh;
  max-width: 100vw;
  overflow-x: hidden;
  background-color: var(--bg-color);
}

#app {
  min-height: 100vh;
  max-width: 100vw;
  overflow-x: hidden;
  position: relative;
}

img {
  max-width: 100%;
  height: auto;
}

button, a {
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* Styles pour résoudre le problème de la barre latérale */
.main-content {
  margin-left: 240px;
  width: 100% !important;
  max-width: 100% !important;
}

.dashboard  {
  background: #f5f5f5 !important;

}
</style>
